export default "__VITE_ASSET__DAhGGGER__"